/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from "react";
import Button, { Icons } from "../buttons/Button";
import CopyButton from "../buttons/CopyButton";
import { errorAlert } from "../../util";

import AuthContext from "../../store/authContext";
import InlineLoader from "../loader/InlineLoader";
import { LOADING_TEXT_TRANSLATIONS } from "../../translations/util";

interface IProps {
  setShowEditPanel: any;
  org: string;
  panelName: string;
  esRef: string;
  formFields: any;
  transformResponseRow: any;
  loadDataByRef: any;
}

const ViewRow = ({
  setShowEditPanel,
  esRef,
  org,
  panelName,
  formFields,
  transformResponseRow,
  loadDataByRef,
}: IProps) => {
  const { token } = useContext(AuthContext);
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  const getDataByRef = async (ref: string) => {
    if (org && token) {
      setDataLoading(true);
      try {
        const response = await loadDataByRef({
          token,
          org,
          ref,
        });
        setData(transformResponseRow(response));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        errorAlert(e);
      } finally {
        setDataLoading(false);
      }
    }
  };

  useEffect(() => {
    getDataByRef(esRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esRef]);

  const hasGroupProfile: boolean = data?.groupProfile;

  return (
    <aside
      id="sidepanel"
      className="sidepanel sidepanel-view fixed z-40 h-full transform transition-transform ease-in duration-150 bg-white"
      data-cy="viewRow-sidepanel"
    >
      <div className="panel-header">
        <div className="panel-left-side">
          <Button
            kind="ghost"
            className="close-btn"
            icon={Icons.Close}
            onClick={() => setShowEditPanel()}
            dataCy="closeViewSidePanel-"
          />
          <h5 data-cy={`${panelName.replaceAll(" ", "")}-sidePanelHeading`}>
            {" "}
            {panelName}{" "}
          </h5>
        </div>
      </div>

      <div className="panel-content">
        {dataLoading ? (
          <InlineLoader
            description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
          />
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {hasGroupProfile ? (
              <div className="view-data">
                <div className="inner-datacontent">
                  <div className="tab-header">
                    <h3> {panelName} </h3>
                  </div>
                  <ul>
                    {formFields
                      .filter((field: any) => field.name !== "groupProfile")
                      .map((field: any) => {
                        return (
                          <li>
                            <h5> {field.label} </h5>
                            <div className="data-content">
                              <span
                                className={field.truncate ? "truncate" : ""}
                              >
                                {data?.[field.name]}
                              </span>
                              {field.hasCopyButton ? (
                                <CopyButton copyContent={data?.[field.name]} />
                              ) : null}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>

                <div className="inner-datacontent mt-5">
                  <div className="tab-header">
                    <h3>Group Profile </h3>
                  </div>

                  <ul>
                    {formFields
                      .find((field: any) => field.name === "groupProfile")
                      ?.value.map((field: any) => {
                        return (
                          <li>
                            <h5> {field.label} </h5>
                            <div className="data-content">
                              <span
                                className={field.truncate ? "truncate" : ""}
                              >
                                {data?.groupProfile?.[field.name]}
                              </span>
                              {field.hasCopyButton ? (
                                <CopyButton
                                  copyContent={data?.groupProfile?.[field.name]}
                                />
                              ) : null}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            ) : (
              <ul className="view-data" data-cy="view-data">
                {formFields
                  .filter((field: any) => field.name !== "groupProfile")
                  .map((field: any) => {
                    return (
                      <li>
                        <h5 data-cy={`${field.label?.replaceAll(" ", "")}`}>
                          {" "}
                          {field.label}{" "}
                        </h5>
                        <div
                          className="data-content"
                          data-cy={`${field.label?.replaceAll(
                            " ",
                            ""
                          )}-content`}
                        >
                          <span className={field.truncate ? "truncate" : ""}>
                            {data?.[field.name]}
                          </span>
                          {field.hasCopyButton ? (
                            <CopyButton copyContent={data?.[field.name]} />
                          ) : null}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            )}
          </>
        )}
      </div>
    </aside>
  );
};

export default ViewRow;
